import styled from 'styled-components';

import { Rating as RatingTP } from '~/src/common/components/Rating/Rating';
import { COLORS } from '~/src/common/theme';
import { FONTS } from '~/src/common/theme';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductName = styled.h1`
  font-size: 22px;
  line-height: 32px;
  font-weight: 700;
  font-family: ${FONTS.ARTZ};
  margin: 0;
`;

export const Granularity = styled.p`
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
`;

export const GranularitySeparator = styled.span`
  margin: 0 8px;
  border-left: 1px solid;
`;

export const PricePerWeight = styled.span`
  color: ${COLORS.NEUTRAL_DISABLED};
`;

export const Rating = styled(RatingTP)`
  [role='meter'] {
    font-size: 16px;
  }

  && p {
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.NEUTRAL_DEFAULT};
  }

  && p:last-child {
    font-weight: 700;
    color: ${COLORS.ACTION_DEFAULT};
  }
`;
